import * as Sentry from '@sentry/browser';
import './style';
import App from './components/app';

Sentry.init({ dsn: 'https://0a24ce04d5c54452a080e66f71befe9b@sentry.io/1496575' });

export default App;
